import React from 'react';
import jurgis from '../../images/logo/jurgis.jpeg';
//import faceLogo from '../../images/logo/Facebook_logo_(square).png';
import instaLogo from '../../images/logo/instagram.png';
import styles from './styles.module.scss';

export default function ContactPage(){

    //const faceUrl = 'https://www.facebook.com/jurgis.bingelis';
    const instaUrl = 'https://www.instagram.com/jurgis.bingelis/';
    const email = 'foto.jurgis@gmail.com';

    return (
        <div className="home-container">

            <div className={styles.main1}>
                <div className={styles.imgDiv}>
                    <img className="img-fluid" alt="Jurgis" src={jurgis} />
                </div>

                <div className={styles.infoDiv}>
                    {/* Klikkbar e-post */}
                    <h6>+47 9674 5992</h6>
                    <h6>
                        <a 
                            href={`mailto:${email}`}
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            {email}
                        </a>
                    </h6>
                    <h6 className="text-center mt-5">Follow me to see more</h6>
                        <a href={instaUrl} target="_blank" rel="noopener noreferrer">
                            <img 
                                className="img-fluid"
                                alt="instaLogo"
                                src={instaLogo}
                                style={{ maxWidth: "30px" }}
                            />
                        </a>
                </div>
            </div>

            <div className="margin-auto d-flex align-items-center justify-content-center gap-3 mt-2 mb-5">

                {/* Facebook klikker */}
                {/* <div className="d-flex justify-content-center" style={{ cursor: 'pointer' }}>
                    <a href={faceUrl} target="_blank" rel="noopener noreferrer">
                        <img 
                            className="img-fluid"
                            alt="faceLogo"
                            src={faceLogo}
                            style={{ maxWidth: "50px" }}
                        />
                    </a>
                </div> */}

                {/* Instagram klikker */}
                {/* <div className="d-flex justify-content-center" style={{ cursor: 'pointer' }}>
                    <a href={instaUrl} target="_blank" rel="noopener noreferrer">
                        <img 
                            className="img-fluid"
                            alt="instaLogo"
                            src={instaLogo}
                            style={{ maxWidth: "50px" }}
                        />
                    </a>
                </div> */}

            </div>
        </div>
    );
}